import { useMemo } from 'react';
import { TelematicDeviceProvider } from '../services/interface/Shared';
import {
	TELEMATICS_ANNUAL_MILEAGE_HELP_TEXT,
	TELEMATICS_TOP_UP_MILES_HELP_TEXT,
	CHECK_MILEAGE_IMS_TEXT,
} from '../utils/modalText';
import { useAppSelector } from './reduxHook';
import { isTelematics } from '../utils';

export const useMileageModalHelperText = (): string => {
	const fullPolicy = useAppSelector((redux) => redux.fullPolicy);
	const annualMileage = useAppSelector((redux) => redux.telematicsDriverMileage.summary?.annualMileageAllowance);
	return useMemo(() => {
		const product = fullPolicy?.product;
		const device = fullPolicy?.coverDetails?.deviceProvider;
		if (!product || !device) return '';

		if (!isTelematics(product)) {
			return '';
		}
		if (import.meta.env.VITE_AUTH_REALM === 'MyPolicy') {
			return TELEMATICS_TOP_UP_MILES_HELP_TEXT(annualMileage ?? 0).concat(
				'<br><br>',
				TELEMATICS_ANNUAL_MILEAGE_HELP_TEXT,
			);
		} else if (device === TelematicDeviceProvider.THINGCO) {
			return TELEMATICS_TOP_UP_MILES_HELP_TEXT(annualMileage ?? 0).concat(
				'<br><br>',
				TELEMATICS_ANNUAL_MILEAGE_HELP_TEXT,
			);
		} else if (device === TelematicDeviceProvider.IMS) {
			return TELEMATICS_ANNUAL_MILEAGE_HELP_TEXT.concat('<br><br>', CHECK_MILEAGE_IMS_TEXT);
		}
		return '';
	}, [fullPolicy.product, fullPolicy.coverDetails.deviceProvider, annualMileage]);
};
